import { Subject } from 'rxjs';
import { QueueEventType } from '../shared/types';
const queues = new Set();
export function createQueue(id) {
    id && queues.add(id);
}
export const queue$ = new Subject();
window.f5.onQueueUpdate((id, event) => {
    if (queues.has(id)) {
        queue$.next({ id, event });
        if (event.type == QueueEventType.Complete) {
            queues.delete(id);
        }
    }
});
